//Interfaces
export interface inputPropertyType {
    isRequired: boolean,
    value: any
}

export interface featuresType {
    key: any,
    value: any
}

export interface titleType {
    isRequired: boolean,
    value: string
}

export interface stateType {
    searchedText: string,
    category: any,
    generalInfo: {
        [key: string]: InputProperty
    },
    features: featuresType[],
    title: {
        [key: string]: InputProperty
    },
    attachments: any, 
    isShowStepTwoValidation: boolean,
    isShowStepThreeValidation: boolean,
    isShowStepFourValidation: boolean,
    isShowStepFiveValidation: boolean,
}

//classes 
export class Features implements featuresType {
    constructor(key: any, value: any) {
        this.key = key;
        this.value = value;
    }
    key: any
    value: any
}

export class InputProperty implements inputPropertyType {
    constructor(isRequired: boolean, value: any) {
        this.isRequired = isRequired;
        this.value = value;
    }
    isRequired: boolean
    value: any
}